import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgFlag = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.677 5.469a.875.875 0 0 0-.302.656V24.5a.875.875 0 1 0 1.75 0v-4.838c2.93-2.314 5.454-1.066 8.362.373 1.793.887 3.725 1.843 5.797 1.843 1.523 0 3.121-.52 4.792-1.968a.874.874 0 0 0 .302-.657V6.125a.875.875 0 0 0-1.451-.656c-3.063 2.65-5.657 1.366-8.664-.123-3.115-1.544-6.646-3.29-10.586.123Zm18.948 13.37c-2.93 2.315-5.454 1.066-8.362-.372-2.734-1.35-5.776-2.858-9.138-.919V6.54c2.93-2.315 5.454-1.067 8.362.371 2.734 1.351 5.777 2.858 9.138.92V18.84Z" />
  </svg>
);
export default SvgFlag;
